import React from "react";
import CustomTabsGrid from "components/CustomTabs/CustomTabsGrid.js";
import BCTaxi from "components/Baocao/Vantaihanhkhach/BCTaxi.js";
//import BCXedulich from "components/Baocao/Vantaihanhkhach/BCXedulich.js";
import BCXehopdong from "components/Baocao/Vantaihanhkhach/BCXehopdong.js";
import BCXetuyencodinh from "components/Baocao/Vantaihanhkhach/BCXetuyencodinh.js";
import BCXebuyt from "components/Baocao/Vantaihanhkhach/BCXebuyt.js";
export default function BCVantaihanhkhach() {
  return (
    <div>
      <CustomTabsGrid
        headerColor="primary"
        tabs={[
          {
            tabName: "Taxi",
            tabContent: <BCTaxi />,
          },
          {
            tabName: "Xe hợp đồng",
            tabContent: <BCXehopdong />,
          },
          {
            tabName: "Xe tuyến cố định",
            tabContent: <BCXetuyencodinh />,
          },
          {
            tabName: "Xe buýt",
            tabContent: <BCXebuyt />,
          },
        ]}
      />
    </div>
  );
}
